import store from "../../store";
import { routes } from "routes/apiRoutes";
import makeRequest from "services/makeRequest";
import { notFoundStatus } from "utils/helper";
import { getTransactionDetails } from "../transactionActions";
import {
  formatUrlQuery,
  isSuccessResponse,
  isAdminUser,
  isAggregatorUser,
} from "utils/helper";
import {
  SET_SELECTED_TERMINAL,
  SET_TRANSACTION_DATES,
  SET_TRANSACTION_VOLUME_DATES,
  SET_SELECTED_TRANSACTION_TYPES,
  SET_TRANSACTION_STATS_TYPES,
  GET_TERMINAL_SUMMARY,
  GET_TERMINAL_SUMMARY_FAIL,
  GET_TERMINAL_SUMMARY_SUCCESS,
  GET_TERMINAL_ACTIVITY,
  GET_TERMINAL_ACTIVITY_SUCCESS,
  GET_TERMINAL_ACTIVITY_FAIL,
  GET_TRANSACTION_TYPE_STATS,
  GET_TRANSACTION_TYPE_STATS_SUCCESS,
  GET_TRANSACTION_TYPE_STATS_FAIL,
  GET_TRANSACTION_BREAKDOWN,
  GET_TRANSACTION_BREAKDOWN_SUCCESS,
  GET_TRANSACTION_BREAKDOWN_FAIL,
  SET_CURRENT_AGENT,
  GET_TRANSACTION_STATUS_STATS,
  GET_TRANSACTION_STATUS_STATS_SUCCESS,
  GET_TRANSACTION_STATUS_STATS_FAIL,
  GET_REGION_STATS,
  GET_REGION_STATS_SUCCESS,
  GET_REGION_STATS_FAIL,
} from "../../types/dashboard/terminalDashboardTypes";

const { dispatch, getState } = store;

const getuserDetails = () => getState()?.user.user;

const getTerminalDetails = () => getState()?.terminalDashboardReducer;

export const setSelectedTransactionTypes = (payload) => {
  dispatch({
    type: SET_SELECTED_TRANSACTION_TYPES,
    payload,
  });

  // getAllData(getBreakDown);
};

export const setTransactionStatsDates = (value, dateType) => {
  dispatch({
    type: SET_TRANSACTION_VOLUME_DATES,
    payload: { value, dateType },
  });
};

export const setTransactionStatsTypes = (payload) => {
  dispatch({
    type: SET_TRANSACTION_STATS_TYPES,
    payload,
  });

  getTransactionStatsBreakdown();
};

export const setTransactionDates = (value, dateType) => {
  dispatch({
    type: SET_TRANSACTION_DATES,
    payload: { value, dateType },
  });
  dispatch({
    type: SET_TRANSACTION_VOLUME_DATES,
    payload: { value, dateType },
  });
};

export const getTerminalSummary = async () => {
  dispatch({ type: GET_TERMINAL_SUMMARY });
  const queryParams = {
    agentId: !isAdminUser(getuserDetails()) && getuserDetails().agent_id,
  };

  try {
    const { data } = await makeRequest(
      "get",
      routes.getTerminalSummary(formatUrlQuery(queryParams))
    );
    if (isSuccessResponse(data)) {
      dispatch({
        type: GET_TERMINAL_SUMMARY_SUCCESS,
        payload: data.data,
      });
    } else {
      dispatch({
        type: GET_TERMINAL_SUMMARY_FAIL,
      });
    }
  } catch (error) {
    if (notFoundStatus(error)) {
      dispatch({
        type: GET_TERMINAL_SUMMARY_FAIL,
      });
    }
    console.log(error);
  }
};

export const getTerminalActivity = async (agentIdToGet) => {
  //Passed agentIdToGetId here 'cause the function is used in aggregator transaction module
  dispatch({ type: GET_TERMINAL_ACTIVITY });

  const {
    agentId,
    selectedTransactionTypes,
    dates: { dateFrom, dateTo },
  } = getTerminalDetails();

  const queryParams = {
    agentId: agentIdToGet || agentId,
    transactionType: selectedTransactionTypes.map(
      (transaction) => transaction.value
    ),
    dateFrom: dateFrom,
    dateTo: dateTo,
  };

  try {
    const { data } = await makeRequest(
      "get",
      routes.getTerminalActivity(formatUrlQuery(queryParams))
    );
    if (isSuccessResponse(data)) {
      dispatch({
        type: GET_TERMINAL_ACTIVITY_SUCCESS,
        payload: data.data,
      });
    } else {
      dispatch({
        type: GET_TERMINAL_ACTIVITY_FAIL,
      });
    }
  } catch (error) {
    if (notFoundStatus(error)) {
      dispatch({
        type: GET_TERMINAL_ACTIVITY_FAIL,
      });
    }
    console.log(error);
  }
};

export const getTransactionTypeStats = async () => {
  dispatch({ type: GET_TRANSACTION_TYPE_STATS });

  const {
    selectedTransactionTypes,
    selectedTerminal,
    agentId,
    dates: { dateFrom, dateTo },
  } = getTerminalDetails();

  const queryParams = {
    agentId,
    type: selectedTransactionTypes.map((transaction) => transaction.value),
    terminalId: selectedTerminal,
    dateFrom: dateFrom,
    dateTo: dateTo,
  };

  try {
    const { data } = await makeRequest(
      "get",
      routes.getTransactionTypeStats(formatUrlQuery(queryParams))
    );
    if (isSuccessResponse(data)) {
      dispatch({
        type: GET_TRANSACTION_TYPE_STATS_SUCCESS,
        payload: data.data,
      });
    } else {
      dispatch({
        type: GET_TRANSACTION_TYPE_STATS_FAIL,
      });
    }
  } catch (error) {
    if (notFoundStatus(error)) {
      dispatch({
        type: GET_TRANSACTION_TYPE_STATS_FAIL,
      });
    }
    console.log(error);
  }
};

export const getTransactionStatsBreakdown = async () => {
  dispatch({ type: GET_TRANSACTION_BREAKDOWN });

  const {
    transactionStatsBreakdown,
    selectedTerminal,
    agentId,
    dates,
    selectedTransactionTypes,
  } = getTerminalDetails();

  const otherQuery = isAdminUser(getuserDetails())
    ? {
        type: selectedTransactionTypes.map((transaction) => transaction.value),
        dateFrom: dates.dateFrom,
        dateTo: dates.dateTo,
      }
    : {
        type: transactionStatsBreakdown.selectedTransactionTypes.map(
          (transaction) => transaction.value
        ),
        dateFrom: transactionStatsBreakdown.dates.dateFrom,
        dateTo: transactionStatsBreakdown.dates.dateTo,
      };

  const queryParams = {
    agentId,
    terminalId: selectedTerminal,
    ...otherQuery,
  };

  try {
    const { data } = await makeRequest(
      "get",
      routes.getTransactionStatsBreakdown(formatUrlQuery(queryParams))
    );
    if (isSuccessResponse(data)) {
      dispatch({
        type: GET_TRANSACTION_BREAKDOWN_SUCCESS,
        payload: data.data,
      });
    } else {
      dispatch({
        type: GET_TRANSACTION_BREAKDOWN_FAIL,
      });
    }
  } catch (error) {
    if (notFoundStatus(error)) {
      dispatch({
        type: GET_TRANSACTION_BREAKDOWN_FAIL,
      });
    }
    console.log(error);
  }
};

export const getRegionStats = async () => {
  dispatch({ type: GET_REGION_STATS });

  const {
    selectedTransactionTypes,
    dates: { dateFrom, dateTo },
  } = getTerminalDetails();

  const queryParams = {
    type: selectedTransactionTypes.map((transaction) => transaction.value),
    dateFrom: dateFrom,
    dateTo: dateTo,
  };

  try {
    const { data } = await makeRequest(
      "get",
      routes.getRegionStats(formatUrlQuery(queryParams))
    );
    if (isSuccessResponse(data)) {
      dispatch({
        type: GET_REGION_STATS_SUCCESS,
        payload: data.data,
      });
    } else {
      dispatch({
        type: GET_REGION_STATS_FAIL,
      });
    }
  } catch (error) {
    if (notFoundStatus(error)) {
      dispatch({
        type: GET_REGION_STATS_FAIL,
      });
    }
    console.log(error);
  }
};

export const getTransactionStatusStats = async () => {
  dispatch({ type: GET_TRANSACTION_STATUS_STATS });

  const {
    selectedTransactionTypes,
    dates: { dateFrom, dateTo },
  } = getTerminalDetails();

  const queryParams = {
    type: selectedTransactionTypes.map((transaction) => transaction.value),
    dateFrom: dateFrom,
    dateTo: dateTo,
  };

  try {
    const { data } = await makeRequest(
      "get",
      routes.getTransactionStatusStats(formatUrlQuery(queryParams))
    );
    if (isSuccessResponse(data)) {
      dispatch({
        type: GET_TRANSACTION_STATUS_STATS_SUCCESS,
        payload: data.data,
      });
    } else {
      dispatch({
        type: GET_TRANSACTION_STATUS_STATS_FAIL,
      });
    }
  } catch (error) {
    if (notFoundStatus(error)) {
      dispatch({
        type: GET_TRANSACTION_STATUS_STATS_FAIL,
      });
    }
    console.log(error);
  }
};

export const setSelectedTerminal = (payload) => {
  dispatch({
    type: SET_SELECTED_TERMINAL,
    payload,
  });

  //   console.log(store.getState());
  getAllData();
};

export const setSelectedAgent = (payload) => {
  dispatch({
    type: SET_CURRENT_AGENT,
    payload,
  });

  //Reset the current terminal chosen to empty so to fetch right data
  dispatch({
    type: SET_SELECTED_TERMINAL,
    payload: undefined,
  });

  getAllData();
};

export const getAllData = (getBreakDown = true) => {
  getTerminalActivity();
  getTransactionTypeStats();

  const isAdmin = isAdminUser(getuserDetails());

  if (getBreakDown) getTransactionStatsBreakdown();

  if (isAdmin) {
    getTransactionStatusStats();
    getRegionStats();
  }

  if (!isAggregatorUser(getuserDetails())) getTransactionDetails();
};
